import React from "react";
import PlusIcon from "app/components/Icons/PlusIcon";
import Dropdown from "app/components/Dropdown";
import clsx from "clsx";
import { Filter } from "../../types";

export default function TicketsFilter({
  options,
  appliedFilterIds,
  onAddFilter,
}: {
  options: Filter[];
  appliedFilterIds: string[];
  onAddFilter: (filter: Filter) => void;
}) {
  const [open, setOpen] = React.useState(false);

  const optionsWithoutSelected = options.filter(
    (filter) => !appliedFilterIds.includes(filter.id),
  );

  const menuItems = optionsWithoutSelected.map((opt) => ({
    label: (
      <div
        className={clsx(
          "flex items-center justify-between gap-1.5 rounded-md w-full",
        )}
      >
        <div className="flex items-center gap-2">
          {opt.icon}
          <span className={clsx("text-sm font-normal text-secondary")}>
            {opt.name}
          </span>
        </div>
      </div>
    ),
    action: () => {
      onAddFilter(opt);
    },
  }));

  return (
    <div className="relative">
      <Dropdown
        open={open}
        setOpen={setOpen}
        trigger={
          <button
            className={clsx(
              "flex items-center justify-between w-full h-8 rounded border text-sm font-semibold outline-none px-2 truncate text-secondary hover:bg-[#E9ECF2] ",
              open ? "border border-secondary" : "border border-gray-200",
            )}
            aria-label="Select sort field"
            aria-expanded={open}
          >
            <div className="flex items-center gap-2 truncate">
              <PlusIcon color="#79808A" size={20} />
              Filter
            </div>
          </button>
        }
        projectInfoIcon={
          <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100 ">
            <span className="text-sm font-semibold text-secondary gap-2 uppercase ">
              filters
            </span>
          </div>
        }
        menuItems={menuItems}
      />
    </div>
  );
}
